<template>
  <nav class="pagination is-centered is-rounded is-small" role="navigation" aria-label="pagination" v-if="max>1">
  <a class="pagination-previous" @click="$emit('prev-page')" v-if="current>1">Anterior</a>
  <a class="pagination-next" @click="$emit('next-page')" v-if="current!=max">Siguiente</a>
  <ul class="pagination-list">
    <li v-if="current>4"><a class="pagination-link" :aria-label="'Goto page'+(1)" @click="$emit('set-page', 1)">1</a></li>
    <li v-if="current>4"><span class="pagination-ellipsis">&hellip;</span></li>

    <li v-if="current==4"><a class="pagination-link" :aria-label="'Goto page'+(1)" @click="$emit('set-page', 1)">1</a></li>
    <li v-if="current>2"><a class="pagination-link" :aria-label="'Goto page'+(current-2)" @click="$emit('set-page', current-2)">{{current-2}}</a></li>
    <li v-if="current>1"><a class="pagination-link" :aria-label="'Goto page'+(current-1)" @click="$emit('set-page', current-1)">{{current-1}}</a></li>

    <li><a class="pagination-link is-current" :aria-label="'Page 46'+(current)" aria-current="page">{{current}}</a></li>

    <li v-if="max > current+1"><a class="pagination-link" :aria-label="'Goto page'+(current+1)" @click="$emit('set-page', current+1)">{{current+1}}</a></li>
    <li v-if="max > current+2"><a class="pagination-link" :aria-label="'Goto page'+(current+2)" @click="$emit('set-page', current+2)">{{current+2}}</a></li>
    <li v-if="max == current+3 || max == current+2 || max == current+1">
      <a class="pagination-link" :aria-label="'Goto page'+(max)" @click="$emit('set-page', max)">{{max}}</a>
      </li>

    <li v-if="current != max && max > current+3"><span class="pagination-ellipsis">&hellip;</span></li>
    <li v-if="current != max && max > current+3"><a class="pagination-link" :aria-label="'Goto page'+(max)" @click="$emit('set-page', max)">{{max}}</a></li>
  </ul>
</nav>
</template>

<script>
export default {
    name: 'StandardPagination',
    props: ['current', 'max']
}
</script>